const Mining = ({
  width = 32,
  height = 32,
  color2 = "#b91321",
  color1 = "#ff8f8f",
  color3 = "#ffffff",
}) => {
  return (
    <svg width={width} height={height} viewBox="0 0 16.933333 16.933333">
      <path
        d="m 10.69599,3.174487 -0.93535,0.935344 5.47719,5.4771846 c 0.10366,0.1036399 0.27048,0.1036399 0.37414,0 0.12474,-0.1247262 0.24939,-0.2494092 0.37413,-0.3741375 0.20733,-0.2072979 0.20733,-0.5409745 0,-0.7482745 z"
        opacity={1}
        fill={color1}
        fillOpacity={1}
        strokeWidth={0.529167}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={4}
        strokeDasharray="none"
      />
      <path
        d="m 10.69599,3.174487 -0.28939,0.289388 5.01726,5.0172651 c 0.20733,0.2073 0.20733,0.5409766 0,0.7482745 -0.0906,0.090618 -0.18121,0.1812144 -0.27181,0.2718181 l 0.0858,0.085783 c 0.10366,0.1036399 0.27048,0.1036399 0.37414,0 0.12474,-0.1247262 0.24939,-0.2494089 0.37413,-0.3741375 0.20733,-0.2072979 0.20733,-0.5409745 0,-0.7482745 z"
        id="path9560"
        fill={color2}
        fillOpacity={1}
        strokeWidth={0.529167}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={4}
        strokeDasharray="none"
      />
      <path
        d="m 8.375382,-5.846755 h 0.8923931 c 0.192576,0 0.3476101,0.1550341 0.3476101,0.3476101 l 0,1.9508014 c 0,0.192576 -0.1550341,0.3476101 -0.3476101,0.3476101 H 8.375382 c -0.192576,0 -0.3476101,-0.1550341 -0.3476101,-0.3476101 l 0,-1.9508014 c 0,-0.192576 0.1550341,-0.3476101 0.3476101,-0.3476101 z"
        id="rect9544"
        fill={color2}
        fillOpacity={1}
        strokeWidth={0.529167}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={4}
        strokeDasharray="none"
        transform="matrix(0.70715716,0.7070564,-0.70715716,0.7070564,0,0)"
      />
      <path
        d="m 9.99859,1.729194 0.93558,-0.93545 0.74846,0.74836 -0.93558,0.93545"
        fill={color2}
        fillOpacity={1}
        strokeWidth={0.529167}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={4}
        strokeDasharray="none"
        transform="matrix(0.70715716,0.7070564,-0.70715716,0.7070564,0,0)"
      />
      <path
        d="m 8.8759,4.348434 -2.26132,2.26615 c 0.1335,-1.30183 0.52917,-2.11666 1.51286,-3.0145 z"
        fill={color2}
        fillOpacity={1}
        strokeWidth={0.529167}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={4}
        strokeDasharray="none"
        transform="matrix(0.70715716,0.7070564,-0.70715716,0.7070564,0,0)"
      />
      <path
        d="M 8.12767,3.600301 C 8.03137,3.688161 7.94529,3.774978 7.85999,3.861784 l 0.41082,0.410311 c 0.0641,0.06415 0.0385,0.113464 0.0176,0.134358 L 6.71228,5.986202 C 6.67208,6.1845174 6.63758,6.390269 6.61458,6.6145872 L 8.87594,4.348576 Z"
        fill={color2}
        fillOpacity={1}
        strokeWidth={0.529167}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={4}
        strokeDasharray="none"
      />
      <path
        d="m 1.322915,9.7895746 h 7.9374967 c 0.2931582,0 0.5291664,0.2360084 0.5291664,0.5291664 v 2.116667 c 0,0.293158 -0.2360082,0.529166 -0.5291664,0.529166 H 1.322915 c -0.2931582,0 -0.52916644,-0.236008 -0.52916644,-0.529166 v -2.116667 c 0,-0.293158 0.23600824,-0.5291664 0.52916644,-0.5291664 z"
        fill={color1}
        fillOpacity={1}
        strokeWidth={0.529167}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={4}
        strokeDasharray="none"
      />
      <path
        d="m 9.26042,9.7895872 v 2.1166668 c 0,0.293158 -0.23601,0.529167 -0.52917,0.529167 h -7.9375 c 0,0.293158 0.23601,0.529166 0.52917,0.529166 h 7.9375 c 0.29315,0 0.52916,-0.236008 0.52916,-0.529166 v -2.116667 c 0,-0.293158 -0.23601,-0.5291668 -0.52916,-0.5291668 z"
        fill={color1}
        fillOpacity={1}
        strokeWidth={0.529167}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={4}
        strokeDasharray="none"
      />
      <path
        d="m 1.322915,12.964578 h 7.9374967 c 0.2931582,0 0.5291664,0.236008 0.5291664,0.529166 v 2.116667 c 0,0.293158 -0.2360082,0.529166 -0.5291664,0.529166 H 1.322915 c -0.2931582,0 -0.52916644,-0.236008 -0.52916644,-0.529166 v -2.116667 c 0,-0.293158 0.23600824,-0.529166 0.52916644,-0.529166 z"
        id="rect9518"
        fill={color2}
        fillOpacity={1}
        strokeWidth={0.529167}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={4}
        strokeDasharray="none"
      />
      <path
        d="m 9.26042,12.964587 v 2.116667 c 0,0.293158 -0.23601,0.529166 -0.52917,0.529166 h -7.9375 c 0,0.293158 0.23601,0.529167 0.52917,0.529167 h 7.9375 c 0.29315,0 0.52916,-0.236009 0.52916,-0.529167 v -2.116666 c 0,-0.293158 -0.23601,-0.529167 -0.52916,-0.529167 z"
        fill={color2}
        fillOpacity={1}
        strokeWidth={0.529167}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={4}
        strokeDasharray="none"
      />
      <path
        d="m 10.93422,0.793754 -0.26459,0.264583 0.48369,0.483692 -0.67076,0.67076 0.26459,0.264583 0.93534,-0.935343 z"
        fill={color2}
        fillOpacity={1}
        strokeWidth={0.529167}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={4}
        strokeDasharray="none"
      />
      <path
        d="m 9.81129,1.685689 c -0.0889,0 -0.17737,0.03424 -0.24547,0.10232 l -0.0191,0.0186 0.61237,0.612366 c 0.13618,0.136162 0.13618,0.355281 0,0.491443 l -1.36064,1.36064 0.0186,0.0186 c 0.13618,0.136162 0.35578,0.136162 0.49196,0 l 1.37925,-1.379243 c 0.13618,-0.136162 0.13618,-0.355281 0,-0.491443 L 10.05729,1.788003 C 9.98919,1.719923 9.90017,1.685683 9.81131,1.685683 Z"
        fill={color2}
        fillOpacity={1}
        strokeWidth={0.529167}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={4}
        strokeDasharray="none"
      />
      <path
        d="M 5 37 C 3.8920005 37 3 37.892001 3 39 L 3 47 C 3 48.107999 3.8920005 49 5 49 L 7 49 C 5.8920005 49 5 48.107999 5 47 L 5 39 C 5 37.892001 5.8920005 37 7 37 L 5 37 z "
        fill={color2}
        fillOpacity={1}
        strokeWidth={0.529167}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={4}
        strokeDasharray="none"
        transform="scale(0.26458333)"
      />
      <path
        d="m 1.3229166,12.964583 c -0.2931581,0 -0.52916661,0.236009 -0.52916661,0.529167 v 2.116666 c 0,0.293159 0.23600851,0.529167 0.52916661,0.529167 h 0.5291667 c -0.2931582,0 -0.5291667,-0.236008 -0.5291667,-0.529167 V 13.49375 c 0,-0.293158 0.2360085,-0.529167 0.5291667,-0.529167 z"
        fill={color2}
        fillOpacity={1}
        strokeWidth={0.529167}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={4}
        strokeDasharray="none"
      />
      <path
        d="M 30.71875 13.607422 C 27.000866 17.000833 25.504567 20.079698 25 25 L 26.863281 23.132812 C 27.505716 19.650705 28.888845 17.101004 31.572266 14.460938 L 30.71875 13.607422 z "
        fill={color2}
        fillOpacity={1}
        strokeWidth={0.529167}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={4}
        strokeDasharray="none"
        transform="scale(0.26458333)"
      />
      <path
        d="M 37.082031 6.3710938 C 36.746174 6.3710937 36.411648 6.5004983 36.154297 6.7578125 L 30.939453 11.970703 C 30.424751 12.485332 30.424751 13.313497 30.939453 13.828125 L 33.324219 16.212891 C 33.83892 16.727519 34.668892 16.727519 35.183594 16.212891 L 35.253906 16.142578 L 32.939453 13.828125 C 32.424751 13.313497 32.424751 12.485332 32.939453 11.970703 L 38.082031 6.828125 L 38.011719 6.7578125 C 37.754368 6.5004983 37.417888 6.3710938 37.082031 6.3710938 z "
        fill={color2}
        fillOpacity={1}
        strokeWidth={0.529167}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={4}
        strokeDasharray="none"
        transform="scale(0.26458333)"
      />
      <path
        d="m 1.3229166,12.964583 c -0.2931581,0 -0.52916661,0.236009 -0.52916661,0.529167 v 2.116666 c 0,0.293159 0.23600851,0.529167 0.52916661,0.529167 h 0.5291667 c -0.2931582,0 -0.5291667,-0.236008 -0.5291667,-0.529167 V 13.49375 c 0,-0.293158 0.2360085,-0.529167 0.5291667,-0.529167 z"
        fill={color2}
        fillOpacity={1}
        strokeWidth={0.529167}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={4}
        strokeDasharray="none"
      />
      <path
        d="M 30.71875 13.607422 C 27.000866 17.000833 25.504567 20.079698 25 25 L 26.863281 23.132812 C 27.505716 19.650705 28.888845 17.101004 31.572266 14.460938 L 30.71875 13.607422 z "
        fill={color2}
        fillOpacity={1}
        strokeWidth={0.529167}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={4}
        strokeDasharray="none"
        transform="scale(0.26458333)"
      />
      <path
        d="M 37.082031 6.3710938 C 36.746174 6.3710937 36.411648 6.5004983 36.154297 6.7578125 L 30.939453 11.970703 C 30.424751 12.485332 30.424751 13.313497 30.939453 13.828125 L 33.324219 16.212891 C 33.83892 16.727519 34.668892 16.727519 35.183594 16.212891 L 35.253906 16.142578 L 32.939453 13.828125 C 32.424751 13.313497 32.424751 12.485332 32.939453 11.970703 L 38.082031 6.828125 L 38.011719 6.7578125 C 37.754368 6.5004983 37.417888 6.3710938 37.082031 6.3710938 z "
        fill={color2}
        fillOpacity={1}
        strokeWidth={0.529167}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={4}
        strokeDasharray="none"
        transform="scale(0.26458333)"
      />
      <path
        d="M 41.326172 3 L 37.789062 6.5351562 L 40.619141 9.3632812 L 41.121094 8.8613281 L 39.271484 7.0097656 L 42.304688 3.9765625 L 41.326172 3 z "
        fill={color2}
        fillOpacity={1}
        strokeWidth={0.529167}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={4}
        strokeDasharray="none"
        transform="scale(0.26458333)"
      />
      <path
        d="M 40.425781 11.998047 L 36.890625 15.533203 L 37.376953 16.019531 L 40.912109 12.484375 L 40.425781 11.998047 z "
        fill={color2}
        fillOpacity={1}
        strokeWidth={0.529167}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={4}
        strokeDasharray="none"
        transform="scale(0.26458333)"
      />
      <path
        d="M 10.748876,0.60731354 9.9214602,1.4336123 c -0.190931,-0.0339 -0.3958017,0.0211 -0.5416125,0.1669198 L 7.9999702,2.9802798 C 7.8548293,3.1253896 7.7994891,3.3292292 7.8320093,3.519779 6.9027043,4.4085776 6.4839422,5.300016 6.3518714,6.5877841 6.3268714,6.8358537 6.627453,6.9777034 6.803054,6.8006837 L 8.9540053,4.6442473 c 0.1918812,0.0341 0.3977421,-0.021 0.543673,-0.1669198 L 9.6263692,4.3486577 15.051819,9.7736093 c 0.204102,0.204039 0.544233,0.204039 0.748334,0 0.137827,-0.1352625 0.285202,-0.2830952 0.407802,-0.41346 0.271202,-0.310149 0.262162,-0.7874382 -0.0331,-1.0826177 L 10.929257,3.0339698 C 11.034398,2.89504 11.073308,2.7205502 11.043478,2.5549305 l 0.826374,-0.8262987 c 0.102611,-0.1032099 0.102611,-0.2698896 0,-0.3730994 L 11.122028,0.60726344 c -0.0515,-0.0519 -0.12225,-0.0801 -0.195361,-0.0779749 -0.06701,0.003025 -0.130551,0.030425 -0.177791,0.078025 z m 0.185781,0.56071906 0.374682,0.3751695 -0.560733,0.5606791 -0.375202,-0.3746494 z m -1.0641368,0.8066088 0.6315448,0.631479 c 0.0358,0.0358 0.0368,0.0815 10e-4,0.1173098 -0.459718,0.4580087 -0.9194189,0.9192242 -1.3798221,1.3794079 -0.0358,0.0358 -0.083101,0.0358 -0.1188607,0 L 8.3733582,3.4713589 c -0.0358,-0.0358 -0.0342,-0.0816 0.00201,-0.1173096 l 1.379878,-1.3797478 c 0.0179,-0.0179 0.0378,-0.0263 0.057637,-0.02613 0.019837,1.7e-4 0.039737,0.00817 0.057637,0.02647 z m 0.6909548,1.4392278 5.238878,5.2383916 c 0.106921,0.1068999 0.106911,0.2662195 0,0.3731094 -0.125936,0.1251463 -0.24814,0.249752 -0.373142,0.3751191 L 9.9996912,3.9755481 Z M 8.1252409,3.9724882 8.5030328,4.3497176 7.1097153,5.7460053 C 7.2941463,5.0948464 7.5714979,4.5329672 8.1252409,3.9724882 Z M 4.613532,4.3554075 c -0.0676,0.00201 -0.1318006,0.0304 -0.1793309,0.0786 -0.1036505,0.1033799 -0.1036505,0.2712696 0,0.3746495 l 0.9354251,0.9358487 c 0.1034505,0.1039897 0.2717514,0.1039897 0.3752019,0 0.1040006,-0.1034399 0.1040006,-0.2717298 0,-0.3751697 L 4.8088932,4.4340075 c -0.0514,-0.0521 -0.1221709,-0.0805 -0.1953612,-0.0786 z M 3.9690787,6.3495845 C 3.8229379,6.3501665 3.7049372,6.4690743 3.7055071,6.6151941 3.7060892,6.7605139 3.8237478,6.8781735 3.9690787,6.8787437 H 5.2915858 C 5.4377265,6.8793258 5.5566572,6.7613237 5.5572271,6.6151941 5.5578092,6.4682641 5.4385266,6.3490045 5.2915858,6.3495845 Z m 1.5783284,1.0588384 c -0.067,0.003 -0.1305406,0.0304 -0.1777809,0.078 L 4.4342011,8.4217614 c -0.1026205,0.1031997 -0.1026205,0.2698993 0,0.3730993 0.1033904,0.10365 0.2713014,0.10365 0.3746921,0 L 5.7448281,7.8595221 c 0.1026205,-0.1031997 0.1026205,-0.2698996 0,-0.3730993 -0.052,-0.0524 -0.1236107,-0.0807 -0.197421,-0.078 z M 1.3225045,9.5255893 c -0.43519235,0 -0.79329431,0.357549 -0.79329431,0.7927087 v 2.117167 c 0,0.20343 0.0805004,0.3882 0.20827106,0.529159 -0.1276306,0.1414 -0.20827106,0.32636 -0.20827106,0.52968 v 2.117166 c 0,0.43516 0.35810196,0.792709 0.79329431,0.792709 h 7.9381624 c 0.4352023,0 0.7948551,-0.357549 0.7948551,-0.792709 v -0.795289 h 0.792785 c 0.435192,0 0.795364,-0.357569 0.795364,-0.792708 v -2.117167 c 0,-0.435159 -0.360172,-0.792709 -0.795364,-0.792709 h -0.792785 v -0.795299 c 0,-0.4351597 -0.3596528,-0.7927087 -0.7948551,-0.7927087 z m 0,0.5291597 h 1.3106269 v 2.644266 H 1.3225045 c -0.1511709,0 -0.2635715,-0.1124 -0.2635715,-0.26355 v -2.117167 c 0,-0.151149 0.1124006,-0.263549 0.2635715,-0.263549 z m 1.8398398,0 h 6.0983226 c 0.1511708,0 0.2656417,0.1124 0.2656417,0.263549 v 2.117167 c 0,0.15115 -0.1144709,0.26355 -0.2656417,0.26355 H 3.1623443 Z m -1.310107,1.057808 c -0.1461409,0 -0.2646114,0.11845 -0.2646114,0.26458 0,0.14613 0.1184705,0.264589 0.2646114,0.264589 0.1461407,0 0.2646014,-0.118459 0.2646014,-0.264589 0,-0.14612 -0.1184707,-0.26458 -0.2646014,-0.26458 z m 2.1168414,10e-4 c -0.1453309,5.82e-4 -0.2630014,0.11823 -0.2635716,0.26355 -5.821e-4,0.14613 0.1174308,0.265049 0.2635716,0.265619 h 4.2347226 c 0.1461309,-5.82e-4 0.2641314,-0.119479 0.2635715,-0.265589 -5.821e-4,-0.14531 -0.1182407,-0.26297 -0.2635715,-0.26354 z m 6.0864433,0.529169 h 0.792785 c 0.151161,0 0.266151,0.11238 0.266151,0.26354 v 2.117167 c 0,0.151149 -0.11499,0.263549 -0.266151,0.263549 h -0.792785 v -0.792708 c 0,-0.20332 -0.080701,-0.38829 -0.2087918,-0.52968 0.128201,-0.140969 0.2087918,-0.325739 0.2087918,-0.529159 z M 1.3225045,13.228664 H 2.6331314 V 15.87499 H 1.3225045 c -0.1511709,0 -0.2635715,-0.1124 -0.2635715,-0.26355 v -2.117166 c 0,-0.15115 0.1124006,-0.26561 0.2635715,-0.26561 z m 1.8398398,0 h 6.0983226 c 0.1511708,0 0.2656417,0.11446 0.2656417,0.26561 v 2.117166 c 0,0.15115 -0.1144709,0.26355 -0.2656417,0.26355 H 3.1623443 Z m 0.8067344,1.058318 c -0.1461508,5.82e-4 -0.2641616,0.11951 -0.2635716,0.26565 5.821e-4,0.14532 0.1182407,0.262979 0.2635716,0.263549 h 4.2347226 c 0.1453308,-5.82e-4 0.2630013,-0.118229 0.2635715,-0.263549 5.821e-4,-0.14613 -0.1174308,-0.26505 -0.2635715,-0.26562 z m -2.1168414,5.29e-4 c -0.1461409,0 -0.2646114,0.11845 -0.2646114,0.26458 0,0.14613 0.1184705,0.264579 0.2646114,0.264579 0.1461307,0 0.2646014,-0.118459 0.2646014,-0.264579 0,-0.14612 -0.1184707,-0.26458 -0.2646014,-0.26458 z"
        color="#000000"
        fontStyle={"normal"}
        fontVariant={"normal"}
        fontWeight={"normal"}
        fontStretch={"normal"}
        fontSize={"medium"}
        lineHeight={"normal"}
        fontFamily={"sans-serif"}
        fontVariantLigatures={"normal"}
        fontVariantPosition={"normal"}
        fontVariantCaps={"normal"}
        fontVariantNumeric={"normal"}
        fontVariantAlternates={"normal"}
        fontFeatureSettings={"normal"}
        textIndent={"0"}
        textAlign={"start"}
        textDecoration={"none"}
        textDecorationLine={"none"}
        textDecorationStyle={"solid"}
        textDecorationColor={"#000000"}
        letterSpacing={"normal"}
        wordSpacing={"normal"}
        textTransform={"none"}
        writingMode={"lr-tb"}
        direction={"ltr"}
        textOrientation={"mixed"}
        dominantBaseline={"auto"}
        baselineShift={"baseline"}
        textAnchor={"start"}
        whiteSpace={"normal"}
        shapePadding={"0"}
        clipRule={"nonzero"}
        display={"inline"}
        overflow={"visible"}
        visibility={"visible"}
        isolation={"auto"}
        mixBlendMode={"normal"}
        colorInterpolation={"sRGB"}
        colorInterpolationFilters={"linearRGB"}
        solidColor={"#000000"}
        solidOpacity={"1"}
        vectorEffect={"none"}
        fill={color2}
        fillOpacity={"1"}
        fillRule={"nonzero"}
        stroke={"none"}
        strokeWidth={"0.99999994"}
        strokeLinecap={"round"}
        strokeLinejoin={"round"}
        strokeMiterlimit={"4"}
        strokeDasharray={"none"}
        strokeDashoffset={"0"}
        strokeOpacity={"1"}
        colorRendering={"auto"}
        imageRendering={"auto"}
        shapeRendering={"auto"}
        textRendering={"auto"}
        enableBackground={"accumulate"}
      />
    </svg>
  );
};
export default Mining;
